import { FC, PropsWithChildren, ReactNode } from 'react'
import { Box, Grid } from '@chakra-ui/react'

interface SidePanelLayoutProps extends PropsWithChildren {
  nav: ReactNode
  isCollapsed: boolean
  isMobileView: boolean
}

export const SidePanelLayout: FC<SidePanelLayoutProps> = ({
  nav,
  children,
  isCollapsed,
  isMobileView,
}) => {
  return (
    <Grid
      templateColumns={isMobileView ? '1fr' : isCollapsed ? '60px 1fr' : '240px 1fr'}
      gap={isMobileView ? 0 : '24px'}
      alignItems="start"
      transition="grid-template-columns 0.22s ease"
    >
      <Box minW={0} overflow="hidden">
        {nav}
      </Box>
      <Box minW={0}>{children}</Box>
    </Grid>
  )
}
